import { ComponentProps, FC, useId } from 'react';
import { Stack, useTheme } from '@mui/material';

interface IStarProps extends ComponentProps<'svg'> {
	filledOn?: number; // 0 to 1
	disabled?: boolean;
}

export const Star: FC<IStarProps> = ({
	filledOn = 0,
	disabled,
	...svgProps
}) => {
	const { palette } = useTheme();
	const gradientId = useId();
	const validatedFilledOn = Math.min(1, Math.max(0, filledOn));
	const isFullyFilled = validatedFilledOn === 1;

	return (
		<Stack
			minHeight={24}
			minWidth={24}
			alignItems="center"
			justifyContent="center"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="19"
				viewBox="0 0 20 19"
				fill="none"
				{...svgProps}
			>
				{!isFullyFilled && (
					<defs>
						<linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id={gradientId}>
							<stop
								offset={validatedFilledOn}
								stopColor={
									disabled ? palette.neutral[60] : palette.primary.main
								}
							/>
							<stop
								offset={validatedFilledOn}
								stopColor={disabled ? 'transparent' : palette.neutral[60]}
							/>
						</linearGradient>
					</defs>
				)}
				<path
					d="M9.52447 1.08156C9.67415 0.620903 10.3259 0.620905 10.4755 1.08156L11.9941 5.75532C12.1949 6.37336 12.7709 6.7918 13.4207 6.7918H18.335C18.8194 6.7918 19.0207 7.4116 18.6289 7.6963L14.6531 10.5848C14.1274 10.9668 13.9074 11.6439 14.1082 12.2619L15.6268 16.9357C15.7765 17.3963 15.2493 17.7794 14.8574 17.4947L10.8817 14.6061C10.3559 14.2242 9.64405 14.2242 9.11832 14.6061L5.14258 17.4947C4.75073 17.7794 4.22349 17.3963 4.37316 16.9357L5.89176 12.2619C6.09257 11.6439 5.87258 10.9668 5.34685 10.5848L1.37111 7.6963C0.979257 7.4116 1.18064 6.7918 1.66501 6.7918H6.57929C7.22913 6.7918 7.80506 6.37336 8.00587 5.75532L9.52447 1.08156Z"
					fill={
						isFullyFilled
							? disabled
								? palette.neutral[60]
								: palette.primary.main
							: `url(#${gradientId})`
					}
					stroke={disabled ? palette.neutral[60] : 'transparent'}
				/>
			</svg>
		</Stack>
	);
};
